import axios from 'axios';

const ROOT = 'api/v1/tasks';

const TaskApi = {
  getAllStudySites() {
    return axios.get(`${ROOT}/study-sites`, { hideLoader: true });
  },

  getAutoPopulationData(request) {
    return axios.post(`${ROOT}/populate`, request, {
      hideLoader: true
    });
  },
  getTaskDetails(taskId, studySiteId) {
    return axios.get(`${ROOT}/${taskId}/study-sites/${studySiteId}`, {
      hideLoader: true
    });
  },
  getAllTasksByFilter(filter, hideLoader) {
    return axios.post(`${ROOT}/work-list`, filter, {
      hideLoader: hideLoader || false
    });
  },
  getTopTenTasks(ssuIds) {
    return axios.post(`${ROOT}/top-ten`, ssuIds, { hideLoader: true });
  },
  exportTasks(filter) {
    return axios.post(`${ROOT}/download`, filter, {
      responseType: 'arraybuffer'
    });
  },
  create(task) {
    return axios.post(`${ROOT}/study-sites/${task.studySiteId}`, task, {
      hideLoader: true
    });
  },
  update(task) {
    return axios.put(`${ROOT}/${task.id}/study-sites/${task.studySiteId}/update`, task, {
      hideLoader: true
    });
  },
  updateStatus(taskId, studySiteId, status) {
    return axios.put(`${ROOT}/${taskId}/study-sites/${studySiteId}/status`, { status }, { hideLoader: true });
  },
  addComment(taskId, ssuId, comment) {
    return axios.post(
      `${ROOT}/${taskId}/study-sites/${ssuId}/comments`,
      { comment },
      {
        hideLoader: true
      }
    );
  },
  addAttachment(taskId, ssuId, file) {
    const formData = new FormData();
    formData.append('file', file);

    return axios.post(`${ROOT}/${taskId}/study-sites/${ssuId}/attachments`, formData);
  },
  previewAttachment(taskId, ssuId, attachmentId, hideLoader = true) {
    return axios.get(`${ROOT}/${taskId}/study-sites/${ssuId}/attachments/${attachmentId}/preview`, {
      hideLoader,
      responseType: 'blob'
    });
  },
  removeAttachment(taskId, ssuId, attachmentId) {
    return axios.delete(`${ROOT}/${taskId}/study-sites/${ssuId}/attachments/${attachmentId}`, {
      hideLoader: true
    });
  },
  getTasksForCalendarView(calendarRequest) {
    return axios.post(`${ROOT}/calendar`, calendarRequest, {
      hideLoader: true
    });
  },
  getUserRolesAllowedForViewTasksPerSsu(taskId, ssuId, userId) {
    return axios.get(`${ROOT}/${taskId}/study-sites/${ssuId}/users/${userId}`);
  },
  getTasksByPatientIdAndSSU(patientId, ssuId) {
    return axios.get(`${ROOT}/patients/${patientId}/ssu/${ssuId}`, {
      hideLoader: true
    });
  },
  getTasksByPatientIdAndEncounter(patientId, encounterId) {
    return axios.get(`${ROOT}/patients/${patientId}/encounters/${encounterId}`, {
      hideLoader: true
    });
  },
  getAllPatientTasksForCreatedTravelRequest(patientId, travelRequestId) {
    return axios.get(`${ROOT}/patients/${patientId}/travel-requests/${travelRequestId}`, {
      hideLoader: true
    });
  },
  getTasksByPatientIdForLogs(patientId, itemGroupKey) {
    return axios.get(`${ROOT}/patients/${patientId}/logs/${itemGroupKey}`, {
      hideLoader: true
    });
  },
  getTaskTopics() {
    return axios.get(`${ROOT}/topics`, {
      hideLoader: true
    });
  },
  getTaskPriorities() {
    return axios.get(`${ROOT}/priorities`, {
      hideLoader: true
    });
  }
};

export default TaskApi;
